import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Select from 'react-select';
import AssignmentIcon from '@mui/icons-material/Assignment';
import {
    ResponsiveContainer,
    ComposedChart,
    Line,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from 'recharts';
import { useNavigate, useLocation } from "react-router-dom";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import Checkbox from "../../../../common/Checkbox";
import Moment from 'moment';
import "moment/locale/ko";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

const StockStatistics = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [tabID, setTabID] = useState('1');
    const [gridWidth, setGridWidth] = useState('600px');
    const [graphData, setGraphData] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        start_date: Moment().format("YYYY-MM-01"),
        end_date: appStore.YYYY_MM_DD(),
        init_item_id: null,
        item_id: null
    });
    const [graphTitle, setGraphTitle] = useState('');
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        item_name: true,
        item_spec: true,
        item_width: false,
        item_depth: false,
        item_height: false,
        stock: false,
        use_stock: false,
        item_total_safe_stock_count: false,
        dp_stock: true,
        dp_use_stock: false,
        dp_item_total_safe_stock_count: true,
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleInitSelect();
            handleMainView();
        }
    }, [MenuID]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.start_date, keyword.end_date, keyword.item_id]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> MenuID 가 0이면 아직 권한 체크가 되지 않았으므로, 권한 체크 후 조회.
        var nextKeyword = null;
        if(tabID === ""){
            setTabID("1");
            return;
        }

        if(tabID === "1"){
            nextKeyword = {
                ...keyword,
                ["item_id"] : null,
                ["start_date"] : Moment().format("YYYY-MM-01"),
                ["end_date"] : appStore.YYYY_MM_DD()
            };
        }else if(tabID === "2"){
            nextKeyword = {
                ...keyword,
                ["item_id"] : null,
                ["start_date"] : Moment().format("YYYY-01-01"),
                ["end_date"] : appStore.YYYY_MM_DD()
            };
        }
        setKeyword(nextKeyword);
    }, [tabID])

    const handleInitSelect = () => {
        setColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_name', headerName: '품목명', width: 120, headerAlign: 'center', align:'left'},
            { field: 'item_spec', headerName: '규격', width: 200, headerAlign: 'center', align:'left' },
            { field: 'item_width', headerName: 'item_width', width: 0, headerAlign: 'center', align:'left' },
            { field: 'item_height', headerName: 'item_height', width: 0, headerAlign: 'center', align:'left' },
            { field: 'item_depth', headerName: 'item_depth', width: 0, headerAlign: 'center', align:'left' },
            { field: 'stock', headerName: 'stock', width: 0, headerAlign: 'center', align:'right' },
            { field: 'use_stock', headerName: 'use_stock', width: 0, headerAlign: 'center', align:'right' },
            { field: 'item_total_safe_stock_count', headerName: 'item_total_safe_stock_count', width: 0, headerAlign: 'center', align:'right' },
            { field: 'dp_stock', headerName: '재고', width: 100, headerAlign: 'center', align:'right' },
            { field: 'dp_use_stock', headerName: '사용가능재고', width: 100, headerAlign: 'center', align:'right' },
            { field: 'dp_item_total_safe_stock_count', headerName: '안전재고', width: 100, headerAlign: 'center', align:'right' }
        ]);
    };

    const handleInit = () => {
        setTabID('');
    };

    // Grid 데이터 조회
    const handleMainView = () => {
        if(keyword.start_date.length === 10 && keyword.end_date.length === 10 && keyword.start_date >= '2025-01-01' && keyword.end_date >= '2025-01-01' && keyword.start_date <= '2049-12-31' && keyword.end_date <= '2049-12-31'){

            axios.get('/api/p/StockStatistics/List',
                {
                params : {
                    start_date : keyword.start_date,
                    end_date : keyword.end_date,
                    status : (tabID === '1')?'1':'2'
                }
            },
            { withCredentials: true }
            )
            .then((response) => { // originrow 저장
                setKeyword({
                    ...keyword,
                    ['item_id']: null,
                    ['init_item_id']: null
                });
            
                const array = (response.data).map((item, index) => ({
                    id: item.item_id,
                    item_name: item.item_name,
                    item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height),
                    item_width: item.item_width,
                    item_depth: item.item_depth,
                    item_height: item.item_height,
                    stock: item.stock,
                    item_total_safe_stock_count: item.item_total_safe_stock_count,
                    use_stock: item.use_stock,
                    dp_stock: String(item.stock).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    dp_item_total_safe_stock_count: String(item.item_total_safe_stock_count).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    dp_use_stock: String(item.use_stock).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }));
                setRows(array);
            })
            .catch((error) => {
                appStore.capture();
            });
        }
    }
    const handleView = () => {
        if(keyword.item_id !== null && keyword.item_id !== 0 && keyword.start_date.length === 10 && keyword.end_date.length === 10 && keyword.start_date >= '2025-01-01' && keyword.end_date >= '2025-01-01' && keyword.start_date <= '2049-12-31' && keyword.end_date <= '2049-12-31'){
            // 그래프 데이터 검색
            if(tabID === "1"){
                axios.get('/api/p/StockStatistics/DateDayGraph',
                    {
                    params : {
                        start_date : keyword.start_date,
                        end_date : keyword.end_date,
                        status : (tabID === '1')?'1':'2',
                        item_id : keyword.item_id
                    }
                },
                { withCredentials: true }
                )
                .then((response) => {
                    setGraphData([]);
                    let graph_array = []
                    if(response.data.length > 0){
                        var safe_stock = String((response.data)[0].item_total_safe_stock_count);
                        var array = response.data.map((item, index) => ({
                            id: item.stock_date,
                            stock_date: item.stock_date,
                            recent_stock: Number(item.recent_stock) < 0?'0':item.recent_stock
                        }));

                        var start_recent_stock = array[0].recent_stock;
                        var curDate = new Date(keyword.start_date);
                        while(curDate <= new Date(keyword.end_date)){
                            var cur_date = (curDate.toISOString()).substr(0, 10);
                            if(array.filter((element) => element.stock_date === cur_date).length === 0){
                                array.push({
                                    id: cur_date,
                                    stock_date: cur_date,
                                    recent_stock: start_recent_stock
                                });
                            }else{
                                start_recent_stock = array.filter((element) => element.stock_date === cur_date)[0].recent_stock;
                            }
                            curDate.setDate(curDate.getDate() + 1);
                        }
                        array.sort((prev, cur) => { 
                            if (prev.id > cur.id) return 1;
                            if (prev.id < cur.id) return -1;
                        });
                        
                        for(let i = 0; i < array.length; i++) {
                            var stock_data = String(array[i].recent_stock)
                            let row = {name: array[i].stock_date, '재고': Number(stock_data.replaceAll(",","")), '안전재고': Number(String(safe_stock).replaceAll(",",""))}
                            graph_array = graph_array.concat(row)
                        }

                    }
                    
                    setOriginRows(graph_array);
                    setGraphData(graph_array);
                    setGraphTitle('일별 품목 재고');
                })
                .catch((error) => {
                    appStore.capture();
                });
            }else if(tabID === "2"){
                axios.get('/api/p/StockStatistics/DateMonthGraph',
                    {
                    params : {
                        start_date : keyword.start_date,
                        end_date : keyword.end_date,
                        status : (tabID === '1')?'1':'2',
                        item_id : keyword.item_id
                    }
                },
                { withCredentials: true }
                )
                .then((response) => {
                    var safe_stock = String((response.data)[0].item_total_safe_stock_count);
                    var array = response.data.map((item, index) => ({
                        id: item.stock_month_date,
                        stock_month_date: item.stock_month_date,
                        recent_stock: Number(item.recent_stock) < 0?'0':item.recent_stock
                    }));

                    var start_recent_stock = 0;
                    if((keyword.start_date).substr(0, 7) === String((response.data)[0].stock_month_date)){
                        start_recent_stock = array[0].recent_stock;
                    }
                    var curDate = new Date(keyword.start_date);
                    while(curDate <= new Date(keyword.end_date)){
                        var cur_month_date = (curDate.toISOString()).substr(0, 7);
                        if(array.filter((element) => element.stock_month_date === cur_month_date).length === 0){
                            array.push({
                                id: cur_month_date,
                                stock_month_date: cur_month_date,
                                recent_stock: start_recent_stock
                            });
                        }else{
                            start_recent_stock = array.filter((element) => element.stock_month_date === cur_month_date)[0].recent_stock;
                        }
                        curDate.setDate(curDate.getDate() + 1);
                    }
                    array.sort((prev, cur) => { 
                        if (prev.id > cur.id) return 1;
                        if (prev.id < cur.id) return -1;
                    });

                    let graph_array = []
                    for(let i = 0; i < array.length; i++) {
                        var stock_data = String(array[i].recent_stock)
                        let row = {name: array[i].stock_month_date, '재고': Number(stock_data.replaceAll(",","")), '안전재고': Number(String(safe_stock).replaceAll(",",""))}
                        graph_array = graph_array.concat(row)
                    }

                    setOriginRows(graph_array);
                    setGraphData(graph_array);
                    setGraphTitle('월별 품목 재고');
                })
                .catch((error) => {
                    appStore.capture();
                });
            }
        }
    }

    const onDateChange = (e)=>{

        var dateType = 'N'
        var tempStartDate = ''
        var tempEndDate = ''

        if (e.target.name === 'start_date'){
            if(Moment(e.target.value).diff(Moment(keyword.end_date),'days') > 0){
                //시작일자를 마지막일자보다 크게 할 경우 마지막일자를 시작일자로 수정
                dateType = 'U'
            }
        } else if (e.target.name === 'end_date'){
            if(Moment(e.target.value).diff(Moment(keyword.start_date),'days') < 0){
                //마지막일자를 시작일자보다 작게 할 경우 시작일자를 마지막일자로 수정
                dateType = 'U'
            }
        } else {
            if((e.target.name === 'start_date' && Moment(e.target.value) > Moment(keyword.end_date))
            || (e.target.name === 'end_date' && Moment(keyword.start_date) > Moment(e.target.value))){
                dateType = 'U'
            }
        }

        if((tabID === "1")){ // 일별
            if (e.target.name === 'start_date'){
                if(Moment(e.target.value).diff(Moment(keyword.end_date),'days') < -31){
                    //시작일자를 1달 이전으로 설정 할 경우 마지막일자를 시작일자와 한달차이로 앞으로 당겨옴
                    dateType = 'D'
                    tempStartDate = e.target.value
                    tempEndDate = Moment(e.target.value).add("1","M").add("-1","d").format("YYYY-MM-DD"); 
                }
            } else if (e.target.name === 'end_date'){
                if(Moment(e.target.value).diff(Moment(keyword.start_date),'days') > 31){
                    //마지막일자를 1달 이후로 설정 할 경우 시작일자를 마지막일자와 한달차이로 당겨옴 
                    dateType = 'D'
                    tempStartDate = Moment(e.target.value).add("-1","M").add("1","d").format("YYYY-MM-DD"); 
                    tempEndDate = e.target.value
                }
            }
        } else if(tabID === "2") { // 월별
            if (e.target.name === 'start_date'){
                if(Moment(e.target.value).diff(Moment(keyword.end_date),'month') < -12){
                    //시작일자를 1년 이전으로 설정 할 경우 마지막일자를 시작일자와 1년차이로 당겨옴 
                    dateType = 'M'
                    tempStartDate = e.target.value
                    tempEndDate = Moment(e.target.value).add("1","Y").format("YYYY-MM-DD"); 
                }
            } else if (e.target.name === 'end_date'){
                if(Moment(e.target.value).diff(Moment(keyword.start_date),'month') > 12){
                    //마지막일자를 1년 이후로 설정 할 경우 시작일자를 마지막일자와 1년차이로 당겨옴 
                    dateType = 'M'
                    tempStartDate = Moment(e.target.value).add("-1","Y").format("YYYY-MM-DD"); 
                    tempEndDate = e.target.value
                }
            }
        }

        if (dateType === 'U') {
            const {name, value} = e.target;
            var startDate = '';
            var endDate = '';
            var nextKeyword = {
                ...keyword,
                ['start_date']: value, 
                ['end_date']: value, 
            };

            if(e.target.name === 'start_date'){
                
                if((((new Date()).toISOString()).substr(0, 10) < value) || (Moment(e.target.value) > Moment(keyword.end_date))){
                    //시작일자 변경 시 : 시작일자가 현재일자 보다 높으면 기본값셋팅(일별 : 시작-현재01일 / 월별 : 시작-현재01월01일 / 종료-현재일자)
                    //console.log('시작일자가 현재일자 보다 높으면 기본값셋팅');
                    if(tabID === "1"){
                        startDate = ((new Date()).toISOString()).substr(0, 8)+'01';
                        endDate = ((new Date()).toISOString()).substr(0, 10);
                    }else if(tabID === "2"){
                        startDate = ((new Date()).toISOString()).substr(0, 5)+'01-01';
                        endDate = ((new Date()).toISOString()).substr(0, 10);
                    }
                }else if(((new Date()).toISOString()).substr(0, 10) >= value){
                    //console.log('시작일자가 현재일자 보다 낮거나 같으면 기본값셋팅');
                   
                    if(tabID === "1"){
                        // 시작일자 변경 시 : 시작일자가 현재일자 보다 낮거나 같으면 -> 종료일자셋팅값(일별 : 시작일자+31)중 일별 종료일자가 현재일자 보다 낮으면 종료일자셋팅값으로 설정
                        // 시작일자 변경 시 : 시작일자가 현재일자 보다 낮거나 같으면 -> 종료일자셋팅값(일별 : 시작일자+31)중 일별 종료일자가 현재일자 보다 높으면 오늘일자로 설정
                        startDate = value;
                        if(Moment(value).add("1","M").add("-1","d").format("YYYY-MM-DD") <= ((new Date()).toISOString()).substr(0, 10)){
                            endDate = Moment(value).add("1","M").add("-1","d").format("YYYY-MM-DD"); 
                        }else{
                            endDate = ((new Date()).toISOString()).substr(0, 10);
                        }
                    }else if(tabID === "2"){
                        // 시작일자 변경 시 : 시작일자가 현재일자 보다 낮거나 같으면 -> 종료일자셋팅값(월별 : 시작년도의말일)중 월별 종료일자가 현재일자 보다 낮으면 종료일자셋팅값으로 설정
                        // 시작일자 변경 시 : 시작일자가 현재일자 보다 낮거나 같으면 -> 종료일자셋팅값(월별 : 시작년도의말일)중 월별 종료일자가 현재일자 보다 높으면 오늘일자로 설정
                        if(Moment(value).format("YYYY-12-31") <= ((new Date()).toISOString()).substr(0, 10)){
                            endDate = Moment(value).format("YYYY-12-31"); 
                        }else{
                            endDate = ((new Date()).toISOString()).substr(0, 10);
                        }
                    }
                }

            } else if(e.target.name === 'end_date'){
                
                if((((new Date()).toISOString()).substr(0, 10) < value) || (Moment(keyword.start_date) > Moment(e.target.value))){
                    //종료일자 변경 시 : 종료일자가 현재일자 보다 높으면 기본값셋팅(일별 : 시작-현재01일 / 월별 : 시작-현재01월01일 / 종료-현재일자)
                    //console.log('종료일자가 현재일자 보다 높으면 기본값셋팅');
                    if(tabID === "1"){
                        startDate = ((new Date()).toISOString()).substr(0, 8)+'01';
                        endDate = ((new Date()).toISOString()).substr(0, 10);
                    }else if(tabID === "2"){
                        startDate = ((new Date()).toISOString()).substr(0, 5)+'01-01';
                        endDate = ((new Date()).toISOString()).substr(0, 10);
                    }
                }else if(((new Date()).toISOString()).substr(0, 10) >= value){
                    //종료일자 변경 시 : 종료일자가 현재일자 보다 낮거나 같으면 -> 시작일자셋팅값(일별 : 월초  / 월별 : 년초)
                    //console.log('종료일자가 현재일자 보다 높으면 기본값셋팅');
                    if(tabID === "1"){
                        startDate = Moment(value).format("YYYY-MM-01");
                    }else if(tabID === "2"){
                        startDate = Moment(value).format("YYYY-01-01");
                    }
                    endDate = value;
                }
            }

            nextKeyword = {
                ...keyword,
                ['start_date']: startDate, 
                ['end_date']: endDate, 
            };

            setKeyword(nextKeyword);
        } else if (dateType === 'N') {
            const {name, value} = e.target;
            const nextKeyword = {
                ...keyword,
                [name]: value, 
            };
            setKeyword(nextKeyword);
        } else if (dateType === 'D') {
            const nextKeyword = {
                ...keyword,
                ['start_date']: tempStartDate, 
                ['end_date']: tempEndDate, 
            };
            setKeyword(nextKeyword);
        } else if (dateType === 'M') {
            const nextKeyword = {
                ...keyword,
                ['start_date']: tempStartDate, 
                ['end_date']: tempEndDate, 
            };
            setKeyword(nextKeyword);
        }

    };

    const handleTabID = (event, newTabID) => {
        setTabID(newTabID);
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '185px', boxShadow: 'none' } }>
                <div className="menu-action" style={ { height: '55px' } }>
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <TabContext value={tabID}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                        <Tab key={1} label={"일별"} value={"1"} />
                        <Tab key={2} label={"월별"} value={"2"} />
                    </TabList>
                    </Box>
                </TabContext>
                <div className="menu-keyword" style={ { paddingTop:'5px' } }>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={ { width: '100px', fontWeight: 'bold' } }>
                            조회기간
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px' } }>
                            <input type="date" value={keyword.start_date} name="start_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                        <div className="menu-keyword-sub-title" style={ { textAlign: 'center', width: '50px' } }>
                            ~
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px'} }>
                            <input type="date" value={keyword.end_date} name="end_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid" style={ { top: '187px' } }>
                <div style={{ float: 'left', width: 'calc('+gridWidth+' - 50px)' }}>
                    <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 287px)', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={rows}
                            columns={columns}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={columnVisibilityModel}
                            onRowSelectionModelChange={(newSelectedIds) => {
                                setKeyword({
                                    ...keyword,
                                    ['item_id']: newSelectedIds[0]
                                });
                            }}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                </div>
                <div style={{ float: 'right', width: 'calc(100% - ('+gridWidth+' + 50px))', paddingRight:'50px'}}>
                    <h3 style={ { margin: '0px', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', fontSize: '24px' } }>{graphTitle}</h3>
                    <div style={{ width: '100%', height: 'calc(100vh - 350px)' }}>
                        {keyword.item_id === null || keyword.item_id === '' || keyword.item_id === '0'?
                        <>
                        <h3 style={ { margin: '0px', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', fontSize: '24px' } }>품목을 선택해주시기 바랍니다.</h3>
                        </>
                        :
                        graphData.length > 0? 
                        <>
                        <ResponsiveContainer>
                            <ComposedChart width={'calc(100% - '+gridWidth+')'} height={'calc(100vh - 350px)'} data={graphData} margin={{ top: 5, right: 5, bottom: 0, left: 50 }}>
                                <CartesianGrid stroke="#f5f5f5" />
                                <XAxis dataKey="name" />
                                <YAxis tickFormatter={tick => { return tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }} />
                                <Tooltip formatter={(okay) => new Intl.NumberFormat('ko').format(okay)} />
                                <Bar dataKey={"재고"} barSize={10} fill="#067ee1" />
                                <Line dataKey={"안전재고"} type="monotone" stroke="#22b14c" fillOpacity={3} />
                            </ComposedChart>
                        </ResponsiveContainer>
                        </>
                        :
                        <>
                        <h3 style={ { margin: '0px', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', fontSize: '24px' } }>조회된 데이터가 없습니다.</h3>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default StockStatistics;